import type { CountertopSection } from '../types';

export type FindCountertopSectionParams = {
	sections: Array<CountertopSection>;
	center: number;
};

/**
 * The section a position falls in. Positions on a boundary resolve to the section to their left,
 * except at the run's left edge where there is no such section.
 * @param params the sections to search and the position to locate
 * @returns the containing CountertopSection, or null when the position is off the run
 */
export const findCountertopSection = (params: FindCountertopSectionParams): CountertopSection | null => {
	const { sections, center } = params;

	return sections.find((section) => center > section.start && center <= section.end)
		?? sections.find((section) => center >= section.start && center <= section.end)
		?? null;
};
